var map = {
	"./ConsentToTreat.document.mdx": [
		89175,
		175
	],
	"./FinancialResponsibility.document.mdx": [
		63043,
		43
	],
	"./PrivacyPolicy.document.mdx": [
		75080,
		80
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 72821;
module.exports = webpackAsyncContext;